<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-tag"></i> 用户管理
                </el-breadcrumb-item>
				<el-breadcrumb-item>独立子公司</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
				<el-input v-model="query.name" placeholder="企业名称" class="handle-input mr10"></el-input>
				&nbsp;&nbsp;
                <el-input v-model="query.contact" placeholder="联系人" class="handle-input mr10"></el-input>
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
            </div>
            <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
                @selection-change="handleSelectionChange"
				:cell-style="{padding:4+'px'}"
				stripe
            >
                <el-table-column type="selection" width="55" align="center"></el-table-column>
				<el-table-column prop="companyCode" label="企业编码"></el-table-column>
                <el-table-column prop="name" label="企业名称"></el-table-column>
				<el-table-column prop="domainName" label="域名"></el-table-column>
				<el-table-column prop="contact" label="联系人"></el-table-column>
				<el-table-column prop="createTime" label="创建时间"></el-table-column>
                <el-table-column label="操作" width="180" align="center">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            icon="el-icon-edit"
                            @click="handleEdit(scope.$index, scope.row)"
                        >编辑</el-button>
                        <!--<el-button
                            type="text"
                            icon="el-icon-delete"
                            class="red"
                            @click="handleDelete(scope.$index, scope.row)"
                        >删除</el-button>-->
                    </template>
                </el-table-column>
            </el-table>
			<div class="record-a-d">
				<!--<el-button
                    type="warning"
                    icon="el-icon-delete"
                    class="handle-del mr10"
                    @click="delAllSelection"
                >批量删除</el-button>-->
				<el-button
                    type="primary"
                    icon="el-icon-lx-add"
                    class="handle-del mr10"
                    @click="handleAdd"
                >添加记录</el-button>
			</div>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>

        <!-- 编辑弹出框 -->
        <el-dialog v-dialogDrag :close-on-click-modal=false :title="title" :visible.sync="editVisible" width="40%">
            <el-form ref="form" :model="form" label-width="120px" :rules="rules">
				<el-tabs v-model="activeName" type="card">
					<el-tab-pane label="企业信息" name="baseTab">
						<el-form-item label="企业编码" prop="companyCode" v-if="form.id">
							<el-input v-model="form.companyCode" disabled></el-input>
						</el-form-item>
						<el-form-item label="名称" prop="name">
							<el-input v-model="form.name"></el-input>
						</el-form-item>
						<el-form-item label="域名" prop="domainName">
							<el-input v-model="form.domainName" style="width:160px"></el-input>&nbsp;.{{website}}
						</el-form-item>
						<el-form-item label="联系人" prop="contact">
							<el-input v-model="form.contact" :disabled="form.id!=undefined"></el-input>
						</el-form-item>
						<el-form-item label="管理员用户名" prop="username" v-if="form.id==undefined">
							<el-input v-model="form.username"></el-input>
						</el-form-item>
						<el-form-item label="管理员密码" prop="password" v-if="form.id==undefined">
							<el-input v-model="form.password" type="password" maxlength="18"></el-input>
						</el-form-item>
						<el-form-item label="确认密码" prop="confirmPassword" v-if="form.id==undefined">
							<el-input v-model="form.confirmPassword" type="password" maxlength="18"></el-input>
						</el-form-item>
					</el-tab-pane>
					<el-tab-pane label="权限" name="authorityTab">
						<v-AuthoritySet ref="authorityTree"></v-AuthoritySet>
					</el-tab-pane>
				</el-tabs>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit" v-prevent-re-click>确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { fetchSubCompanyData, saveSubCompany, deleteSubCompany, getSubCompany, getAuthorityRouteTreeData, getMyCompanyWebsite, getCompanyAuthority } from '../../../api/index';
import vAuthoritySet from '../../common/AuthoritySet.vue';
export default {
    name: 'sub-company',
    data() {
		let checkNum = (rule, value, callback) => {
			const numReg = /^[0-9]*$/
			if (value) {
				if (numReg.test(value)) {
					callback()
				} else {
					callback(new Error('企业编码为数值型'));
				}
			} else {
				callback(new Error('请输入企业编码'));
			}
		}
		
		let checkNumNotEmpty = (rule, value, callback) => {
			const numReg = /^[0-9]*$/
			if (value) {
				if (numReg.test(value)) {
					callback()
				} else {
					callback(new Error('用户量为数值型'));
				}
			} else {
				callback();
			}
		}
		
		let validatePass = (rule, value, callback) => {
			if (!this.form.id) {
				if (!value) {
					callback(new Error('请输入新密码'));
				} else if (value.toString().length < 6 || value.toString().length > 18) {
					callback(new Error('密码长度为6 - 18个字符'))
				} else {
					callback();
				}
			}
		}
		
		let validatePass2 = (rule, value, callback) => {
			if (!this.form.id) {
				if (value === '') {
					callback(new Error('请再次输入密码'));
				} else if (value !== this.form.password) {
					callback(new Error('两次输入密码不一致!'));
				} else {
					callback();
				}
			}
		}
		
        return {
            query: {
                code: '',
                name: '',
                pageNum: 1,
                pageSize: 10
            },
            tableData: [],
            multipleSelection: [],
            editVisible: false,
            pageTotal: 0,
            form: {},
            idx: -1,
            id: -1,
			title:"",
			isDisabled:false,
			rules: {
                companyCode: [{ required: true, validator: checkNum, trigger: 'blur' }],
                name: [{ required: true, message: '企业名称不能为空', trigger: 'blur' }],
				domainName: [{ required: true, message: '域名不能为空', trigger: 'blur' }],
				contact: [{ required: true, message: '联系人不能为空', trigger: 'blur' }],
				username: [{ required: true, message: '管理员不能为空', trigger: 'blur' }],
				password: [{ required: true, validator:validatePass, trigger: 'blur' }],
				confirmPassword: [{ required: true, validator: validatePass2, trigger: 'blur' }],
            },
			activeName:"baseTab",
			treeDatasource:[],
			applyCompanyKeys:[],
			website:""
        };
    },
    created() {
        this.getData();
		this.getRouteTreeData();
		this.getOwnCompanyAuthority();
		this.getWebsite();
    },
	components: {
        vAuthoritySet
    },
    methods: {
        // 获取 easy-mock 的模拟数据
        getData() {
            fetchSubCompanyData(this.query).then(res => { 
				if (res.code == 0 ) {
					this.tableData = res.data.records;
					this.pageTotal = res.data.total;
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
            });
        },
		getWebsite() {
			getMyCompanyWebsite().then(res => { 
				if (res.code == 0 ) {
					this.website = res.data;
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
            });
		},
		// 获取树形结构数据
        getRouteTreeData() {
            getAuthorityRouteTreeData().then(res => { 
				if (res.code == 0 ) {
					this.treeDatasource = res.data;
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
            });
        },
		//获取企业权限
		getOwnCompanyAuthority() {
			getCompanyAuthority().then(res => { 
				if (res.code == 0 ) {
					this.applyCompanyKeys = res.data;
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
            });
		},
        // 触发搜索按钮
        handleSearch() {
            this.$set(this.query, 'pageNum', 1);
			this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },
        // 删除操作
        handleDelete(index, row) {
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					deleteSubCompany([row.id]).then(res => {
						if (res.code == 0) {
							this.$message.success('删除成功');
							this.getData();
						} else {
							this.$message.error(`删除失败！` + res.message);
						}
					});
                })
                .catch(() => {});
        },
        // 多选操作
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        delAllSelection() {
            const length = this.multipleSelection.length;
			if (length == 0) {
				this.$message.error(`请选择要删除的记录！`);
				return;
			}
            let ids = [];
            for (let i = 0; i < length; i++) {
				ids.push(this.multipleSelection[i].id)
            }
			this.$confirm('确定要删除选中的记录吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					deleteSubCompany(ids).then(res => {
						if (res.code == 0) {
							this.$message.success('删除成功');
							this.getData();
						} else {
							this.$message.error(`删除失败！` + res.message);
						}
					});
				})
				.catch(() => {});
        },
		//添加操作
		handleAdd() {
			this.form = {};
			this.title = "添加新纪录";
			this.isDisabled = false;
			this.editVisible = true;
			this.activeName = "baseTab";
			this.$nextTick(()=>{
				this.$refs.authorityTree.setDatasource(this.treeDatasource, [], this.applyCompanyKeys);
			});
		},
        // 编辑操作
        handleEdit(index, row) {
            this.idx = index;
            //this.form = row;
			this.title = "编辑";
			this.isDisabled = true;
			this.activeName = "baseTab";
			getSubCompany(row.id).then(res => {
				if (res.code == 0) {
					this.form = res.data;
					this.form.domainName = this.form.domainName.replace("." + this.website, "")
					this.editVisible = true;
					let authority = this.form.authority?JSON.parse(this.form.authority):[];
					this.$nextTick(()=>{
						this.$refs.authorityTree.setDatasource(this.treeDatasource, authority);
					});
				} else {
					this.$message.error(`获取数据详情失败！` + res.message);
				}
			})
        },
        // 保存编辑
        saveEdit() {
			this.$refs.form.validate(valid => {
				if (valid) {
					let checkedKeys = this.$refs.authorityTree.getCheckedKeys();
					this.form["authority"] = JSON.stringify(checkedKeys);
					saveSubCompany(this.form).then(res => {
						if (res.code == 0) {
							this.$message.success('保存成功！');
							this.editVisible = false;
							this.getData();
						} else {
							this.$message.error(`保存失败！` + res.message);
						}
					})
				} else {
					this.$message.error('数据信息不完整！');
				}
			});
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageNum', val);
			this.$set(this.query, 'pageIndex', val);
            this.getData();
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.record-a-d {
	float:left; 
	padding-top:20px;
}
</style>
